// @ts-nocheck
import React,{useState}  from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import FabIcon from '../Componentes/IconsJS/FabIcon.jsx';
import localStorageManagement from '../Security/LocalStorageManagement';
import CardHeader from '@mui/material/CardHeader';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { themeCardSizes} from "./Home";
import { styled } from '@mui/material/styles';
import SinapThemev2 from "../styles/SinapThemev2";


const StyledCard = styled('div')(({ theme }) => ({
    paddingTop:16,
    "& > div":{
        paddingBottom:0,
        cursor: 'pointer',
        boxShadow: ' 0px 6px 4px rgba(0, 0, 0, 0.25), 0px 0px 4px rgba(0, 0, 0, 0.25) ',
        transition: 'height 0.5s ease',
        height: theme.miniCard.miniHeight,
        width: theme.miniCard.miniWidth,
        "& span":{
            marginTop: '-5px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            //Title
            "& p":{
                marginBottom: '5px',
                textAlign: 'center',
                margin:'0',
                fontSize: '24px',
                height: '29px',
                transition: 'fontSize 1s ease-out'
            }
        }
    },
}));

export default function MiniRedirectCard({info}) {

    const addViewToLocalStorage = () => {
        localStorageManagement.addSystemView(info);
    }

    const redirectTo = () => {
        addViewToLocalStorage();
        window.open(info.link, '_blank', 'noopener,noreferrer')
    }

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={SinapThemev2}>
                   <StyledCard theme={themeCardSizes}>
                       <Card onClick={redirectTo}>
                           <CardHeader
                               title={
                                   <>
                                       <Typography noWrap gutterBottom variant="h5" color="primary" >
                                           {info.title}
                                       </Typography>
                                       <FabIcon img={info.image}/>
                                   </>
                               }
                           />
                       </Card>
                   </StyledCard>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}